export enum TestGroupKey {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export enum TestGroupSlug {
  Control = 'control',
  Test = 'test'
}

export interface TestGroup {
  keys: TestGroupKey[]
  slug: string
  description?: string
  isDefault?: boolean
}

export enum TestSlug {
  Example = 'exampleSlug',
  ShowNpsOnlyEndOfWeekAfterLunch = 'showNpsOnlyEndOfWeekAfterLunch',
  OnboardingProjectTemplatesByIndustry = 'onboardingProjectTemplatesByIndustry'
}

export interface Test {
  startDate: Date
  groups: TestGroup[]
}

const LIVE = new Date('2000-01-01')

export const abTests = new Map<TestSlug, Test>([
  [
    TestSlug.ShowNpsOnlyEndOfWeekAfterLunch,
    {
      startDate: LIVE,
      groups: [
        {
          keys: [TestGroupKey.A, TestGroupKey.B],
          slug: TestGroupSlug.Control,
          description: 'Control group: Show NPS whenever',
          isDefault: true
        },
        {
          keys: [TestGroupKey.C, TestGroupKey.D],
          slug: TestGroupSlug.Test,
          description: 'Test group: Show NPS only at the end of the week after lunch'
        }
      ]
    }
  ],
  [
    TestSlug.OnboardingProjectTemplatesByIndustry,
    {
      startDate: LIVE,
      groups: [
        {
          keys: [TestGroupKey.A, TestGroupKey.B],
          slug: TestGroupSlug.Control,
          description: 'Control group: Show project templates as is (with industry-based template)',
          isDefault: true
        },
        {
          keys: [TestGroupKey.C, TestGroupKey.D],
          slug: TestGroupSlug.Test,
          description: 'Test group: Hide industry-based public project template'
        }
      ]
    }
  ]
])
